import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Optional,
  Output,
  ViewContainerRef,
} from '@angular/core';

import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { DIALOG_DATA } from '../../../../../global.variable';
import { AppService } from '../../../../app.service';
import { ConfirmDialogComponent } from '../../../../shared/components/confirm-dialog/confirm-dialog.component';
import { DialogRef } from '../../../../shared/components/modal-dialogue/modal-dialogue.ref';
import { ModalDialogueService } from '../../../../shared/components/modal-dialogue/modal-dialogue.service';
import { DataCheckService } from '../../../../shared/services/data-check.service';
import { LoadingSpinnerService } from '../../../../shared/services/loading-spinner.service';
import { ToasterService } from '../../../../shared/services/toaster.service';
import { UsersService } from '../users.service';
import { SubContactorsService } from '../../sub-contractors/sub-contactors.service';
import { firstValueFrom, lastValueFrom } from 'rxjs';
import { JobsService } from '../../jobs/jobs.service';
import { Capacitor } from '@capacitor/core';

@Component({
  selector: 'gtapp-add-edit-user',
  templateUrl: './add-edit-user.component.html',
  styleUrl: './add-edit-user.component.scss',
  standalone: false,
})
export class AddEditUserComponent implements OnInit {
  userForm: UntypedFormGroup = new UntypedFormGroup({
    email: new UntypedFormControl('', [Validators.required, Validators.email]),
    first_name: new UntypedFormControl('', Validators.required),
    last_name: new UntypedFormControl('', Validators.required),
    display_name: new UntypedFormControl(''),
    contact_number: new UntypedFormControl(''),
  });
  @Output() userUpdated = new EventEmitter();

  @Input() editUser: any;
  @Input() detailData: any;
  @Input() fromUserPage: boolean = false;

  permanentSlotsAvailable: boolean = false;

  userGroupListData: any = [];
  userGroupListDataBackup: any = [];
  isUserAboveManager: boolean = false;
  isUserOwner: boolean = false;

  userData: any;
  userFullName: string = '';

  reportsConfigured: any;

  showGroupInfo: boolean = false;
  editUserDetails: boolean = false;

  selectedSubContractor: any = {};
  subContractorLookupListData: any = [];
  subContractorSearchString: string = '';
  showSubcontractor: boolean = false;

  initialDataList: any = {};

  isDialogBox: boolean = false;

  isSubscriberAdmin = this.dataCheckService.isSubscriberAdmin();
  isAdmin: boolean = this.dataCheckService.isUserAdmin();
  isSuperUser: boolean = this.dataCheckService.isSuperUser();

  userAccessStatus: number = 1;

  perDayPerUserPrice: number = 0;

  isFreeAccessAccount: boolean = false;

  availableJobTypeListData: any = [];

  isNativeApp = Capacitor.isNativePlatform();

  constructor(
    @Optional() protected dialogRef: DialogRef,
    private appService: AppService,
    private userService: UsersService,
    private spinnerService: LoadingSpinnerService,
    private router: Router,
    private dataCheckService: DataCheckService,
    private dialogService: ModalDialogueService,
    @Optional() @Inject(DIALOG_DATA) public dialogueData: any,
    private toasterService: ToasterService,
    private contractorService: SubContactorsService,
    private viewContainerRef: ViewContainerRef,
    private jobService: JobsService,
  ) {
    this.userData = this.appService.getUserData();
  }

  async ngOnInit() {
    if (this.dialogueData) {
      this.editUser = this.dialogueData?.editUser || this.editUser;
      this.detailData = this.dialogueData?.detailData || this.detailData;
      this.fromUserPage = this.dialogueData?.fromUserPage || this.fromUserPage;

      this.isDialogBox = true;
    }

    if (this.editUser == true) {
      this.userForm.controls['first_name'].removeValidators(
        Validators.required,
      );
      this.userForm.controls['last_name'].removeValidators(Validators.required);
      this.userForm.controls['first_name'].updateValueAndValidity();
      this.userForm.controls['last_name'].updateValueAndValidity();

      this.userService
        .getUserById(
          this.detailData.pk ? this.detailData.pk : this.detailData.id,
          { reports_configured: this.fromUserPage ? 1 : 0 },
        )
        .subscribe((response: any) => {
          if (response['status'] == 'success') {
            this.formatData(response);
          }
        });
    } else {
      this.permanentSlotsAvailable =
        (await this.isPermanentSlotAvailable()) || this.permanentSlotsAvailable;
    }
    this.checkAddUserConditions();
    if (this.fromUserPage) {
      if (!this.editUser) this.onContractorLookup();

      this.getUserGroups();
      this.getAllPossibleJobTypes();
    }
  }
  async isPermanentSlotAvailable(): Promise<boolean> {
    const response: any = await lastValueFrom(
      this.userService.getUserListData({ get_count: 1 }),
    );

    this.perDayPerUserPrice =
      response?.per_day_per_guard_price || this.perDayPerUserPrice || 0;

    return (
      (response?.allotted_slots || 0) >
      (response?.total_permanent_user_count || 0)
    );
  }
  checkAddUserConditions() {
    this.isFreeAccessAccount = this.dataCheckService.isFreeAccessAccount();

    if (this.isFreeAccessAccount) this.permanentSlotsAvailable = false;
    if (!this.permanentSlotsAvailable) this.userAccessStatus = 2;
  }
  addMoreUserSlots() {
    this.router.navigate(['/subscription'], {
      fragment: 'addUser',
    });
  }

  isUserGroupPrivilageCheck() {
    this.detailData?.user_group?.forEach((item: any) => {
      if ([4].includes(item?.group_identity)) {
        this.isUserOwner = true;
      }
      if ([1, 4].includes(item?.group_identity)) {
        this.isUserAboveManager = true;
      }
    });
  }
  async formatData(response: any) {
    this.permanentSlotsAvailable =
      (await this.isPermanentSlotAvailable()) || this.permanentSlotsAvailable;

    this.detailData = response['data'];

    this.reportsConfigured = response?.reports_configured;
    this.perDayPerUserPrice =
      response?.per_day_per_guard_price || this.perDayPerUserPrice || 0;

    this.selectedSubContractor = this.detailData?.sub_contractor || {};

    this.userFullName = (this.detailData?.full_name || '')?.trim();

    this.userAccessStatus = this.detailData?.access_status;

    this.formatGroupList();

    this.isUserOwner = false;
    this.isUserAboveManager = false;
    this.spinnerService.hide();
    this.isUserGroupPrivilageCheck();
  }
  formatGroupList() {
    const removeUserGroups = [4];
    const checkUserStatusVal = this.detailData?.id
      ? this.detailData?.access_status
      : this.userAccessStatus;
    if (checkUserStatusVal == 2) {
      removeUserGroups.push(1);
    }

    this.userGroupListData = this.userGroupListDataBackup?.filter(
      (item: any) => !removeUserGroups?.includes(item?.group_id),
    );
    if (this.detailData?.user_group?.length) {
      this.userGroupListData?.forEach((grp: any) => {
        grp.disabled = this.disableSelectOption(grp);
        grp.selected = this.detailData?.user_group?.some(
          (selectedGrp: any) => selectedGrp?.id === grp?.id,
        );
      });
    } else {
      this.userGroupListData?.forEach((grp: any) => {
        grp.selected = grp?.group_id === 2;
      });
    }
  }
  getAllPossibleJobTypes() {
    this.jobService.getJobParams().subscribe((response: any) => {
      this.availableJobTypeListData = response?.data || [];
    });
  }

  getUserGroups() {
    this.userService.getUserGroups({ rows: 10 }).subscribe((response: any) => {
      if (response['status'] == 'success') {
        this.userGroupListDataBackup = response?.data || [];
        this.formatGroupList();
      }
    });
  }

  onCloseDialogue(val: any = 'submit') {
    if (this.isDialogBox) {
      this.dialogRef.close(val);
    } else {
      this.userUpdated.emit(val);
    }
  }

  //Send the invitation link in user's email
  sendAddUserLink() {
    this.spinnerService.show('Adding New User');

    const grpIds = [
      ...new Set(
        this.userGroupListData
          ?.filter((grp: any) => grp?.selected)
          ?.map((grp: any) => grp?.id),
      ),
    ];
    const userTagJobTypeIds = [
      ...new Set(
        this.availableJobTypeListData
          ?.filter((jType: any) => jType?.selected)
          ?.map((jType: any) => jType?.id),
      ),
    ];

    let requestData = {
      data: {
        ...this.userForm.value,
        group_ids: grpIds,
        sub_contractor_id: this.selectedSubContractor?.id,
        access_status: this.userAccessStatus,
        user_tag_data: { job_type_ids: userTagJobTypeIds || [] },
      },
    };
    this.userService.addUser(requestData).then((response: any) => {
      if (response['status'] == 'success') {
        this.router.navigate(['/users'], { fragment: undefined });
        this.onCloseDialogue(response?.data);
        this.spinnerService.hide();
      } else {
        this.toasterService.setMessage({
          errorMessage: response['message'],
          successMessage: '',
        });
        this.spinnerService.hide();
      }
    });
  }
  reInviteUser(data: any) {
    let dialogMsg = `Send ${data?.email} another email to sign into Guard Tracker?`;
    const dialogRef = this.dialogService.open(ConfirmDialogComponent, {
      data: {
        title: 'Resend User Sign In Link',
        message: dialogMsg,
      },
    });
    dialogRef.afterClosed().subscribe((value) => {
      if (value === true) {
        this.spinnerService.show();
        let requestData = { data: { subscriber_user_id: data?.id } };
        this.userService
          .addUser(requestData, { re_invite: 1 })
          .then((response: any) => {
            if (response['status'] == 'success') {
              this.spinnerService.hide();
              this.onCloseDialogue(response?.data);
              this.toasterService.setMessage({
                successMessage: response['message'],
                errorMessage: '',
              });
            } else {
              this.spinnerService.hide();
              this.toasterService.setMessage({
                errorMessage: response['message'],
                successMessage: '',
              });
            }
          });
      }
    });
  }
  disableOrEnableUser(id: any) {
    this.spinnerService.show();
    this.userService.userEnableDisable(id).then((response: any) => {
      if (response['status'] == 'success') {
        this.toasterService.setMessage({
          successMessage: response['message'],
          errorMessage: '',
        });
        this.spinnerService.hide();
        this.formatData(response);
        this.onCloseDialogue(response?.data);
      } else {
        this.spinnerService.hide();
        this.toasterService.setMessage({
          errorMessage: response['message'],
          successMessage: '',
        });
      }
    });
  }
  deleteUserById(data: any) {
    let dialogMsg = `Delete ${data?.full_name || data?.email}? `;
    const dialogRef = this.dialogService.open(ConfirmDialogComponent, {
      data: {
        title: 'Delete User',
        message: dialogMsg,
      },
    });
    dialogRef.afterClosed().subscribe((value) => {
      if (value === true) {
        this.spinnerService.show();
        this.userService.deleteUserById(data?.id).then((response: any) => {
          if (response['status'] == 'success') {
            this.onCloseDialogue('deleted');
            this.toasterService.setMessage({
              successMessage: response['message'],
              errorMessage: '',
            });
            this.spinnerService.hide();
          } else {
            this.spinnerService.hide();
            this.toasterService.setMessage({
              errorMessage: response['message'],
              successMessage: '',
            });
          }
        });
      }
    });
  }

  addRemoveGroup(groupId: string, action: String = 'add') {
    this.spinnerService.show();
    const actionParam: any = { reports_configured: this.fromUserPage ? 1 : 0 };
    actionParam[action === 'add' ? 'add_group' : 'remove_group'] = 1;

    this.updateUser(
      {
        id: this.detailData.id,
        group_id: groupId,
      },
      actionParam,
    );
  }
  addRemoveTag(tagId: any, jTypeId: string, action: String = 'add') {
    this.spinnerService.show();
    const actionParam: any = { reports_configured: this.fromUserPage ? 1 : 0 };
    actionParam[action === 'add' ? 'add_tag' : 'remove_tag'] = 1;

    this.updateUser(
      {
        id: this.detailData.id,
        job_type_id: jTypeId,
        tag_id: tagId || null,
      },
      actionParam,
    );
  }

  disableSelectOption(grpData: any) {
    if (
      this.detailData?.user_group?.length === 1 &&
      this.detailData?.user_group?.some(
        (grpId: any) => grpId?.id === grpData?.id,
      )
    ) {
      // if only one group is there block its unselection
      return true;
    }
    if (grpData?.group_id === 1 && this.detailData?.subscriber_admin) {
      // block removal of subscriber admin
      return true;
    }
    if (
      grpData?.group_id === 1 &&
      this.userData?.subscriber?.subscriber_user_id === this.detailData?.id
    ) {
      // logged in Managers user cannot remove himself from Managers group
      return true;
    }
    if (grpData?.group_id === 4) {
      // block Allowing to select the other user as Administrator group.
      return true;
    }
    return false;
  }
  updateUser(body: any, params: any) {
    this.spinnerService.show();
    this.userService.updateUser(body, params).then((response: any) => {
      if (response['status'] == 'success') {
        this.formatData(response);
        if (!this.isDialogBox) {
          this.userUpdated.emit(response?.data);
        }

        this.toasterService.setMessage({
          successMessage: response['message'],
          errorMessage: '',
        });
      } else {
        this.spinnerService.hide();
        this.toasterService.setMessage({
          successMessage: '',
          errorMessage: response['message'],
        });
      }
    });
  }
  changeDefaultReportRecipent() {
    this.updateUser(
      {
        id: this.detailData.id,
      },
      { default_recipient: 1 },
    );
  }
  addRemoveReportRecipients(action: String = 'add') {
    let paramDict: any = {
      modify_report_recipient: 1,
      reports_configured: this.fromUserPage ? 1 : 0,
    };
    paramDict[action === 'add' ? '' : 'remove_as_report_recipient'] = 1;
    let dialogMsg =
      action === 'add'
        ? `Send this email address reports for all completed jobs and existing scheduled patrol route reports.`
        : `Do not send completed job reports to this email address. \nRemove this email address from all scheduled reports.`;
    const dialogRef = this.dialogService.open(ConfirmDialogComponent, {
      data: {
        title: 'Reporting',
        message: dialogMsg,
      },
    });
    dialogRef.afterClosed().subscribe((value) => {
      if (value === true) {
        this.updateUser(
          {
            id: this.detailData.id,
          },
          paramDict,
        );
      }
    });
  }
  updateDisplayName() {
    const fullName =
      `${(this.userForm.value?.first_name || '')?.trim()} ${(this.userForm.value?.last_name || '')?.trim()}`?.trim();
    if (fullName) this.userForm.controls['display_name'].setValue(fullName);
  }
  mobileNumberCheck() {
    if (!this.userForm.value?.contact_number) {
      this.userForm.controls['contact_number'].setValue(null);
      this.userForm.controls['contact_number'].removeValidators([
        Validators.minLength(7),
        Validators.maxLength(10),
        //Validators.pattern('^((\\+91-?)|0)?[0-9]{10}$'),
        Validators.pattern('^(\\+?(61|64|675)|0)?[0-9]{7,10}$'),
      ]);
    } else {
      this.userForm.controls['contact_number'].setValidators([
        Validators.minLength(7),
        Validators.maxLength(10),
        //Validators.pattern('^((\\+91-?)|0)?[0-9]{10}$'),
        Validators.pattern('^(\\+?(61|64|675)|0)?[0-9]{7,10}$'),
      ]);
    }
  }
  editUserDetailsFn() {
    this.editUserDetails = true;
    this.onContractorLookup();
    this.showSubcontractor = this.selectedSubContractor?.id;
    this.userForm.patchValue(this.detailData);
    this.userForm.patchValue({
      display_name: this.detailData?.user_add_info?.display_name,
      contact_number: this.detailData?.user_add_info?.contact_number,
    });
  }
  updateUserDetails() {
    this.spinnerService.show();
    this.updateUser(
      {
        id: this.detailData?.id,
        display_name: this.userForm.value?.display_name,
        contact_number: this.userForm.value?.contact_number,
        sub_contractor_id: this.selectedSubContractor?.id,
      },
      { update_additional_info: 1, update_subcontractor: 1 },
    );
  }
  clearField(fieldId: string) {
    this.userForm.controls[fieldId].setValue('');
    this.shiftFocus(fieldId);
  }
  shiftFocus(elementId: string, time: number = 100) {
    setTimeout(() => {
      var element = <HTMLInputElement>document.getElementById(elementId);

      if (element) {
        element?.focus();
      }
    }, time);
  }
  updateInitialDataList(field: any) {
    this.subContractorLookupListData = [];
    setTimeout(() => {
      if (field === 'contractors') {
        this.subContractorLookupListData = JSON.parse(
          JSON.stringify(this.initialDataList?.[field] || []),
        );
      }
    }, 200);
  }
  editField(field: string) {
    if (field == 'contractors') {
      this.shiftFocus('contractorFieldId');
      this.updateInitialDataList(field);
    }
  }
  onContractorLookup(event?: any) {
    const searchStr = event?.target?.value || '';
    this.subContractorSearchString = searchStr;
    let params: any = {};
    if (searchStr) {
      params.search_str = searchStr;
    }

    this.contractorService.getContactors(params).then((response: any) => {
      if (response['status'] == 'success') {
        this.subContractorLookupListData = response?.data;
        if (!searchStr) {
          this.initialDataList['contractors'] = response?.data;
        }
      }
    });
  }

  onContractorSelect(contractorData: any) {
    if (contractorData.key === 0) {
      this.onAddNewSubcontractor();
    }
    if (contractorData?.id) {
      this.selectedSubContractor = contractorData;
    }
  }
  onAddNewSubcontractor() {
    if (this.subContractorSearchString?.length > 0) {
      let requestData = {
        company_name: this.subContractorSearchString,
      };

      this.contractorService
        .addContractor(requestData)
        .then((response: any) => {
          if (response?.status == 'success') {
            this.onContractorSelect(response?.data);
          } else {
            this.toasterService.setMessage({
              errorMessage: response['message'],
              successMessage: '',
            });
          }
        });
    } else {
      this.toasterService.setMessage({
        errorMessage: "Contractor Name can't be empty",
        successMessage: '',
      });
    }
  }
  async openTemplate(
    template: any,
    source: 'subcontractor' | 'userInformation',
  ) {
    let dialogData: any = {};
    switch (source) {
      case 'subcontractor':
        this.onContractorLookup();
        break;
      case 'userInformation':
        dialogData = {
          newInfromation: this.detailData?.additional_info?.user_note || '',
          oldInfromation: this.detailData?.additional_info?.user_note || '',
        };
        break;
    }

    this.dialogService.open(
      template,
      { data: dialogData },
      this.viewContainerRef,
    );
  }

  setUnsetSubContractor() {
    if (this.showSubcontractor) {
      this.showSubcontractor = false;
      this.selectedSubContractor = null;
    } else {
      this.showSubcontractor = true;
    }
  }
  showUserStats() {
    this.router.navigate([`/user-stats`], {
      queryParams: { uId: this.detailData?.id },
    });
  }
  async updateUserAccessStatus() {
    if (this.isFreeAccessAccount) {
      //   free access account; conversion not possible
      this.dialogService.open(ConfirmDialogComponent, {
        data: {
          title: '',
          btn2Detail: {
            text: 'OK',
            class: 'btn-primary',
          },
          message: `Unable to make users ${this.userAccessStatus == 1 ? 'casual' : 'permanent'} while free access has been granted.`,
        },
      });

      return;
    }
    if (this.userAccessStatus == 2 && !this.permanentSlotsAvailable) {
      //   permanent slots are not available
      const dialogRef = this.dialogService.open(ConfirmDialogComponent, {
        data: {
          title: 'Make User Permanent',
          btn2Detail: {
            text: this.isSubscriberAdmin ? 'Yes' : 'OK',
            class: this.isSubscriberAdmin ? 'btn-success' : 'btn-primary',
          },
          message: this.isSubscriberAdmin
            ? `All permanent slots allocated, purchase additional permanent user slot?`
            : 'All permanent slots allocated.',
        },
      });
      const res = await firstValueFrom(dialogRef.afterClosed());

      if (res === true && this.isSubscriberAdmin) {
        this.addMoreUserSlots();
      }

      return;
    }

    const dialogRef = this.dialogService.open(ConfirmDialogComponent, {
      data: {
        title: this.userAccessStatus == 1 ? 'Make User Casual' : '',
        message:
          this.userAccessStatus == 1
            ? this.isNativeApp
              ? ``
              : `Casual users will incur a fee of $${this.perDayPerUserPrice} per day, per user.\n\nThis only applies if the user has been assigned to a shift and/or has added any updates.`
            : 'Make user permanent?',
      },
    });
    const res = await firstValueFrom(dialogRef.afterClosed());

    if (res === true) {
      this.updateUser(
        {
          id: this.detailData.id,
        },
        {
          change_status: 1,
          access_status: this.userAccessStatus == 1 ? 2 : 1,
        },
      );
    }
  }
  routeToClient(client: any) {
    this.router.navigate([
      '/view-client',
      { cKey: String(client?.company_id) },
    ]);
  }
}
